import biliShare from '@bilibili/share-h5-next'
import '@bilibili/share-h5-next/dist/share-h5.css'
const UA = window.navigator.userAgent
export const isWechat = /MicroMessenger/i.test(UA)

const loop = () => {}
export default (success = loop, cancel = loop) => {
  const shareInfo = {
    title: '2020年bilibili追番报告', // 分享标题
    desc: '去年你都看了哪些动画，请查收这份报告~', // 分享描述
    pics: 'https://i0.hdslb.com/bfs/activity-plat/static/d1cf92bc9dbcd4aba66a240199ecc790/share_bgm_2021.jpg',
    link: window.shareUrl, // 分享链接，必传，请传一个可以访问的url
    // edit_content: `去年你都看了哪些动画，请查收这份报告~ ${origin + pathname}`, // 动态预设文案
    edit_content: '', // 动态预设文案
    success,
    cancel,
  }
  // 设置右上角
  biliShare.setContent(shareInfo)
}
